export default "__VITE_ASSET__0f2a0fb3__"